export default __webpack_public_path__ + "static/media/loginimg1.6301017e.png";